import { atom } from "jotai";
import { SetStateAction } from "react";

import { SNHUService } from "./snhu.service";
import { Pages } from "./snhu.types";

export const pagesAtom = atom<Pages>(Pages.OPTIN);

export const progressAtom = atom<number, SetStateAction<number>>(
  (get) => {
    const page = get(pagesAtom);

    const pagesLength = Object.keys(Pages).length;
    const valueIndex = Object.values(Pages).indexOf(page as Pages);

    return Math.floor(((valueIndex + 1) / pagesLength) * 100);
  },
  (get, set, update) => {
    const newValue =
      typeof update === "function" ? update(get(progressAtom)) : update;
    set(progressAtom, newValue);
  }
);

export const snhuCompletedAtom = atom<boolean>(
  async () => {
    const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
    const userEmail = submission?.data?.email;
    return SNHUService.getHasCompletedSNHU(userEmail);
  }
);
